import { defineMessages } from 'react-intl-next';

export default defineMessages({
    prompt: {
        defaultMessage: 'Did this article help?',
        description: 'Prompt message in knowledgebase article feedback collector in customer portal article view',
        id: 'sd.kb.feedback.collector.prompt',
    },
    yes: {
        defaultMessage: 'Yes',
        description: 'Expresses that the knowledgebase article was helpful',
        id: 'sd.common.words.yes',
    },
    no: {
        defaultMessage: 'No',
        description: 'Expresses that the knowledgebase article was not helpful',
        id: 'sd.common.words.no',
    },
    helpfulResponse: {
        defaultMessage: 'Thanks for your feedback. Have a good day!',
        description: 'Message displayed when customer clicks on the thumbs up icon, saying the article is helpful',
        id: 'sd.kb.feedback.collector.helpful.response',
    },
    unHelpfulResponse: {
        defaultMessage: 'Thanks for your feedback.',
        description:
            'Message displayed when customer clicks on the thumbs down icon, saying the article is not helpful',
        id: 'sd.kb.feedback.collector.not.helpful.response',
    },
});
